export const RefreshIcon = () => (
  <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.9751 6.48669C16.6655 3.69851 13.6747 1.75 10.1946 1.75C5.79408 1.75 2.17579 4.8657 1.75 8.85503"
      stroke="#F06D24"
      strokeWidth="1.97362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.438 6.48667H18.1721C18.4533 6.48667 18.6813 6.2746 18.6813 6.013V2.53943"
      stroke="#F06D24"
      strokeWidth="1.97362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.45605 12.8023C3.76563 15.5905 6.75643 17.539 10.2365 17.539C14.637 17.539 18.2554 14.4233 18.6811 10.434"
      stroke="#F06D24"
      strokeWidth="1.97362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.99328 12.8022H2.25919C1.97797 12.8022 1.75 13.0143 1.75 13.2759V16.7495"
      stroke="#F06D24"
      strokeWidth="1.97362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
